import type { QueryParams, ViewSwitcherVariables } from '@/view-switch/view-switch-controller';
import type { FormControlChangeListener } from "./form-manager";
import { Controller } from "@hotwired/stimulus";
import { controlTag } from './form-control-initializer';

export interface FormControlAutosaveApi {
    save(control: AbstractFormControl<HTMLElement>): void;
    debounce?(control: AbstractFormControl<HTMLElement>): void;
    onSuccess?(callback: () => void): void;
    onError?(callback: () => void): void;
}

export abstract class AbstractFormControl<E extends HTMLElement> extends Controller<E> {

    abstract getName(): string;
    abstract getValue(): any;
    abstract setValue(value: any): void;

    formatValue() {
        return this.getValue();
    }

    connect(): void {
        controlTag.add(this);
    }

    disconnect(): void {
        controlTag.remove(this); 
    }

    /** Gets data to be appended to a FormData object for submission */
    getData(): any {
        return this.getValue();
    }

    appendData(form: FormData) {
        let name = this.getName();
        let data = this.getData();
        if (Array.isArray(data)) {
            data.forEach(item => form.append(name + '[]', item));
        } else {
            form.append(name, data);
        }
    }

    // FormData needs to be included for file uploads
    addData(form: FormData, variables: {[name: string] : any}) {
        variables[this.getName()] = this.getData();
    }

    hasValue(value: any): boolean {
        return this.getValue() == value;
    }

    isEmpty(): boolean {
        return this.hasValue('') || this.hasValue(null);
    }

    focus(): void {
        this.element.focus();
    }

    select(): void {
        
    }

    setEnabled(enabled: boolean): void {

    }

    enable(): void {
        this.setEnabled(true);
    }

    disable(): void {
        this.setEnabled(false);
    }

    setVariables(variables) {

    }

    contains(el: HTMLElement) {
        return this.element.contains(el);
    }

    addChangeListener(onChange: FormControlChangeListener) {
        this.element?.addEventListener('change', () => onChange(this));
    }

    initAutosave(autosave: FormControlAutosaveApi) {
        this.addChangeListener(c => autosave.save(c));
    }

    addQueryParams(params: QueryParams) {
        params[this.getName()] = this.getValue();
    }

    removeQueryParams(params: QueryParams) {
        delete params[this.getName()];
    }

    /** Opportunity to save data when switching out views. Variables already contain the url params. */
    saveState(variables: ViewSwitcherVariables): void {
    }

    restoreState(variables: ViewSwitcherVariables): void {
        this.setValue(variables.inputs[this.getName()]);
    }

    matches(text: string): boolean {
        return false;
    }
}
